/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refresh_ResultsInputs */

const en_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh Results`)
};

const fr_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les résultats`)
};

const de_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse aktualisieren`)
};

const it_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna i risultati`)
};

const ru_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить результаты`)
};

const es_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar resultados`)
};

const zh_cn2_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新结果`)
};

const ja_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果を更新`)
};

const hi_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणाम रीफ़्रेश करें`)
};

const pt_pt2_refresh_results = /** @type {(inputs: Refresh_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar resultados`)
};

/**
* | output |
* | --- |
* | "Refresh Results" |
*
* @param {Refresh_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const refresh_results = /** @type {((inputs?: Refresh_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refresh_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_refresh_results(inputs)
	if (locale === "de") return de_refresh_results(inputs)
	if (locale === "it") return it_refresh_results(inputs)
	if (locale === "ru") return ru_refresh_results(inputs)
	if (locale === "es") return es_refresh_results(inputs)
	if (locale === "zh-CN") return zh_cn2_refresh_results(inputs)
	if (locale === "ja") return ja_refresh_results(inputs)
	if (locale === "hi") return hi_refresh_results(inputs)
	if (locale === "pt-PT") return pt_pt2_refresh_results(inputs)
	return en_refresh_results(inputs)
});